export default {
    cz: {
        title: 'Výsledky vyhledávání: ',
    },
    sk: {
        title: 'Výsledky vyhľadávania: ',
    },
}
